var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map",
    transform: "translate(-170 -137)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_5",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 5",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(170 137)",
    fill: "#3a4557"
  }), /*#__PURE__*/React.createElement("path", {
    id: "solid_map-marker-alt",
    "data-name": "solid map-marker-alt",
    d: "M4.71,13.718C.737,7.958,0,7.367,0,5.25a5.25,5.25,0,0,1,10.5,0c0,2.117-.737,2.708-4.71,8.468a.657.657,0,0,1-1.079,0Zm.54-6.28A2.187,2.187,0,1,0,3.062,5.25,2.187,2.187,0,0,0,5.25,7.437Z",
    transform: "translate(176.75 142)",
    fill: "#fc1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.2eb3d01afd57365cc4929f9b47afab89.svg";
export { ForwardRef as ReactComponent };